import type { CommandFactory } from './types'

export const themeCommand: CommandFactory = (context) => ({
  id: 'theme',
  name: 'theme',
  description: 'Create a theme from a description',
  acceptsArgs: true,
  handler: async (args?: string) => {
    if (!args || args.trim() === '') {
      context.onDisplayMessage?.({
        role: 'command',
        content:
          'Please provide a theme description. Usage: `/theme <your theme description>`',
        timestamp: new Date(),
      })
      return
    }

    // Submit a message that will prompt the AI to use the create_theme tool
    context.onSubmitMessage?.(
      `Use the create_theme tool to create a color theme (NOT an HTML artifact) based on this description: ${args.trim()}. The theme must include both light and dark mode color palettes.`
    )
  },
})
